<div class="tw-flex tw-items-center tw-justify-center" *ngIf="loading">
  <bit-icon name="bwi-spinner" class="bwi-spin bwi-3x" [ariaLabel]="'loading' | i18n"></bit-icon>
</div>
<auth-input-password
  *ngIf="!loading"
  [hidden]="true"
  [email]="email"
  [flow]="inputPasswordFlow"
  [masterPasswordPolicyOptions]="masterPasswordPolicyOptions"
  [loading]="submitting"
></auth-input-password>
<vbango-room-enrollment
  *ngIf="!loading"
  [busy]="mechanismBusy || submitting"
  (secretSubmitted)="onMechanismSecret($event)"
></vbango-room-enrollment>
